<template>
  <v-btn v-if="extension" @click.native.stop="pay">
    <v-chip>
      <price class="mr-2" :value="extension.state.credits" :currency="platform.currency" />
      Recharger
    </v-chip>
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex'
import { Price } from '@/components/formatters'
export default {
  components: {
    Price
  },
  computed: {
    ...mapGetters({
      platform: 'skiliko/session/currentPlatform',
      currentUser: 'skiliko/session/currentUser'
    }),
    extension () {
      return this.platform.metadata.extensions['credit']
    }
  },
  methods: {
    async pay () {
      const endpoint = `https://functions.${process.env.ENDPOINT}/stripe-session`
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          price: process.env.STRIPE_PRICE_ID,
          quantity: 5,
          success_url: window.location.href,
          cancel_url: window.location.href,
          platform: this.platform.id.toString(),
          platform_url: this.platform.url,
          email: this.currentUser.email
        })
      })
      const { id, error } = await response.json()
      if (error) throw error
      const stripe = window.Stripe(process.env.STRIPE_PUB_KEY)
      await stripe.redirectToCheckout({ sessionId: id })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/extensions/credit/value.vue